import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  role: null,
  token: null,
  email: null,
  userId: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.role = action.payload.role;
      state.token = action.payload.token;
      state.email = action.payload.email;
      state.userId = action.payload.userId;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.role = null;
      state.token = null;
      state.email = null;
      state.userId = null;
      localStorage.removeItem("access_token")
      localStorage.removeItem("userInfo")
    },

  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
